import 'intersection-observer'

/*
header의 컬러가 변경되어야 하는 section에 진입할때 마다, 색상을 바꾸기 위해서
이벤트가 실행되는 시점을 컬러가 변경되어야 하는 section에 진입할때가 아닌
변경되어야하는 section의 바로 전에 없어지는 section이 사라지는 시점에서
section의 데이터속성[data-style]을 가져와서 header에 background-color을 변경.
*/
export default {
  data () {
    return {
      ioSection: null,
      intersectingList: [],
      attributeName: 'style',
      changeData: 'default'
    }
  },
  beforeDestroy () {
    if (this.ioSection) {
      this.ioSection.disconnect()
      this.ioSection = null
      delete document.querySelector('header').dataset.style
    }
  },
  mounted () {
    // TODO: component를 찾지 못하는 문제 해결 필요
    setTimeout(this.initObserver, 300)
  },
  methods: {
    onObserver (entries) {
      const header = document.querySelector('header')
      // 리스트에서 타겟과 같은 클래스가 있는지 찾기
      if (this.intersectingList[0]) {
        const n = this.intersectingList[0].findIndex(e => {
          return e.target.className === entries[0].target.className
        })
        if (n === -1) {
          this.intersectingList = [...this.intersectingList, entries]
        }
      } else {
        this.intersectingList = [...this.intersectingList, entries]
      }

      entries.forEach(({ target, isIntersecting, intersectionRatio, boundingClientRect }) => {
        // 현재 section이 몇번째 인지 구하기.
        const currentIndex = this.intersectingList[0].findIndex(ele => {
          return ele.target.className === target.getAttribute('class')
        })

        // 스크롤 up, down 구분.
        if (boundingClientRect.top < 0) {
          if (isIntersecting) {
            // console.log('up')
            if (!(intersectionRatio < 0)) {
              this.changeData = this.intersectingList[0][currentIndex] && this.intersectingList[0][currentIndex].target.dataset[this.attributeName]
            }
          } else {
            // console.log('down')
            if (!(intersectionRatio > 0) && currentIndex > 0) {
              if (this.intersectingList[0][currentIndex + 1]) {
                this.changeData = this.intersectingList[0][currentIndex + 1].target.dataset[this.attributeName]
              } else {
                this.changeData = this.intersectingList[0][0].target.dataset[this.attributeName]
              }
            }
          }
        } else {
          // 스크롤이 일어나기전 최상단에 스크롤이 위치하는 경우
          if (window.scrollY === 0 && currentIndex === 0) {
            this.changeData = this.intersectingList[0][0].target.dataset[this.attributeName]
          }
        }

        if (this.changeData) {
          header.dataset.style = this.changeData
        } else {
          header.dataset.style = 'default'
        }
      })
    },
    setObserver () {
      this.ioSection = new IntersectionObserver(this.onObserver, {
        threshold: [0],
        rootMargin: '0px 0px 0px 0px'
      })
    },
    initObserver () {
      const ele = this.$el.querySelectorAll('section')
      this.setObserver()
      ele.forEach(v => {
        this.ioSection.observe(v)
      })
    }
  }
}
